import { FormInstance } from 'antd/lib/form';
import type { FormTextEditorProps } from '../templates/FormTextEditor';
import FormTextEditor from '../templates/FormTextEditor';

interface Content<T> extends Omit<FormTextEditorProps<T>, 'content'> {
  form: FormInstance;
  editItem: string;
  height?: number;
}

const Content = <T,>({
  name = 'content',
  label = 'Content',
  placeholder = 'Enter Content',
  rules,
  required = true,
  form,
  editItem,
  height,
  ...props
}: Content<T>) => {
  return (
    <FormTextEditor
      content={editItem}
      {...{ name, label, placeholder, form, required, rules, height }}
      {...props}
    />
  );
};

export default Content;
